import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../features/auth/stores/authStore';
import { Routes as AppRoutes } from '../../routes';
import type { NavigationItem } from '../components/layout/navigationItems';

/** Shared navigation handler — navigates to item path or performs item action (e.g. logout). */
export function useNavigationHandler() {
  const navigate = useNavigate();
  const { logout } = useAuthStore();

  return (item: NavigationItem) => {
    if (item.action === 'logout') {
      navigate(AppRoutes.login);
      logout('manual_user_action');
    } else {
      navigate(item.path);
    }
  };
}
